// Copyright (c) 2016 Deere & Company

import SpaClaimContainer from '../../claim/spa/state-connector';

export default {
    component: SpaClaimContainer,
    name: 'SPECIAL_ALLOWANCE_CLAIM',
    path: 'spa/new(/:pin)'
};



// WEBPACK FOOTER //
// ./src/routes/claims/spa-claim-route.js